import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DelonACLModule } from '@delon/acl';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-peppol-status',
  templateUrl: './peppol-status.component.html',
  styles: [],
  standalone: true,
  imports: [
    CommonModule,
    NzTagModule,
    DelonACLModule,
    NzToolTipModule
  ]
})
export class PeppolStatusComponent {
  @Input() value: any;
  @Output() statusChange = new EventEmitter<string>();
  
  onStatusChange(newStatus: string) {
    this.value = newStatus;
    this.statusChange.emit(newStatus);
  }
}
